var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-chip',_vm._g(_vm._b({staticClass:"primary--text",attrs:{"label":"","color":"red","small":""}},'v-chip',attrs,false),on),[_c('v-icon',{attrs:{"left":"","small":""}},[_vm._v(" mdi-alert ")]),_vm._v(" Alto riesgo ")],1)]}}])},[_c('span',[_vm._v("Se encontraron evaluaciones en semáforo rojo para este evaluado.")])])}
var staticRenderFns = []

export { render, staticRenderFns }